import {getService, postBodyService} from "./base.service";
import config from "../config/application";

//url
const read = '/channelEntityPayment/read/';
const add = '/channelEntityPayment/add';
const deleteChannelEntityPayment = '/channelEntityPayment/delete';
const update = '/channelEntityPayment/update';
const findByConcept = '/channelEntityPayment/find_by_concept/';

class ChannelEntityPaymentService {
    findByConcept(concept) {
        const url = `${config.data.income.channelEntityPayment.url}${findByConcept}${concept}`;
        return getService(url);
    }
    getChannelEntityPayment(channelEntityPayment) {
        const url = `${config.data.income.channelEntityPayment.url}${read}${channelEntityPayment}`;
        return getService(url);
    }
    getCreateChannelEntityPayment(json) {
        const url = `${config.data.income.channelEntityPayment.url}${add}`;
        return postBodyService(url, json);
    }
    getDeleteChannelEntityPayment(json) {
        const url = `${config.data.income.channelEntityPayment.url}${deleteChannelEntityPayment}`;
        return postBodyService(url,json);
    }
    getUpdateChannelEntityPayment(json) {
        const url = `${config.data.income.channelEntityPayment.url}${update}`;
        return postBodyService(url, json);
    }
}
export default new ChannelEntityPaymentService();